import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";

import settings from "./settings";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    settings,
    auth,
  },
  state: {},
  mutations: {},
  actions: {},
});
